export type SubscriptionListener<T> = (data: T) => void;

export interface Subscription<T,K = void> {
    data: K
    remove: () => void
}

export class SubscriptionHandler<T, K = void> {
    private readonly listeners: SubscriptionListener<T>[] = [];

    add(listener: SubscriptionListener<T>, data: K) {
        this.listeners.push(listener);

        return <Subscription<T,K>>{
            data,
            remove: () => this.remove(listener)
        }
    }

    private remove(listener: SubscriptionListener<T>) {
        const index = this.listeners.indexOf(listener);
        if (index >= 0) {
            this.listeners.splice(index, 1);
        }
    }

    publish(data: T) {
        for (const listener of this.listeners) {
            try {
                listener(data);
            } catch (e) {
                console.error(e);
            }
        }
    }
}
